// Generated from SVG to Code Figma Plugin

export const ProductLineReference = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.39305 14.165L5.38856 15.1704C5.00322 15.5561 4.73028 16.0396 4.59908 16.5688L4.0783 18.6693C3.86091 19.5461 4.65375 20.3396 5.53077 20.123L7.64676 19.6004C8.17762 19.4693 8.66254 19.1956 9.04912 18.8089L10.1576 17.7M12.6785 15.1782L13.5 14.3564L19.3743 8.47999C20.3825 7.47143 20.3825 5.83663 19.3744 4.82803C18.3654 3.81865 16.7291 3.81887 15.7204 4.82852L11.1734 9.37998L9.57994 10.975L8.78322 11.7725"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.6992 2.41504C11.8199 2.67229 12.0261 2.87913 12.2832 3C12.0263 3.12075 11.82 3.32711 11.6992 3.58398C11.5783 3.32684 11.3715 3.12069 11.1143 3C11.3718 2.87918 11.5784 2.67255 11.6992 2.41504Z"
      stroke="currentColor"
      strokeWidth="1.6875"
    />
    <path
      d="M9.68562 6.6009C7.78599 5.81347 6.11633 5.78406 5.20164 6.69875C3.52651 8.37388 5.01779 12.5811 8.5325 16.0958C12.0472 19.6105 16.2544 21.1018 17.9296 19.4267C18.9375 18.4187 18.799 16.4939 17.763 14.3548"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
